import React from "react";
import rehypeReact from "rehype-react";
import { Table, List, Button, Icon } from "semantic-ui-react";
import { I18Link, UmLink } from "../components/i18link";
import { Address, Email } from "../components/social";

const renderAst = new rehypeReact({
  createElement: React.createElement,
  components: {
    table: ({ children }) => (
      <Table celled padded>
        {children}
      </Table>
    ),
    ul: ({ children, ...others }) => (
      <List bulleted {...others}>
        {children}
      </List>
    ),
    li: ({ children, ...others }) => (
      <List.Item {...others}>{children}</List.Item>
    ),
    ilink: ({ children, ...others }) => (
      <I18Link {...others}>{children}</I18Link>
    ),
    umlink: ({ children, ...others }) => (
      <UmLink {...others}>{children}</UmLink>
    ),
    "custom-btn": ({children, icon, ...others }) => (
      <Button primary size="tiny" {...others} style={{marginTop: "10px", marginBottom: "10px" }} >
        { icon && <Icon name={icon} /> }
        &nbsp;{children}
      </Button>
    ),
    "social-address": Address,
    "social-email": Email,
  },
  // components: { "my-component": MyComponent }
}).Compiler;

export default renderAst;
